import { ImmutableObject } from 'seamless-immutable';
import * as types from '../constants/actionTypes';
import initialState from './initialState';
import * as messageUtils from '../functions/messageUtils';
import { IAction } from '../interfaces/IAction';
import { ChatStateType } from 'redhotpie-shared-lib/constants/chatStateTypes';

export interface ChatStateEntry {
  chatStateType: ChatStateType;
  updatedTime: number;
}

export interface IChatState {
  byId: Record<string, ChatStateEntry>;
}

export default function chatStateReducer(
  state: ImmutableObject<IChatState> = initialState.chatState,
  action: IAction
): ImmutableObject<IChatState> {
  const { type, chatStateMessage } = action;

  switch (type) {
    case types.CHAT_UPDATE_CHAT_STATE: {
      if (!chatStateMessage) {
        return state;
      }
      const { type: chatStateType } = chatStateMessage;
      const chatId = messageUtils.removePrefixAndSuffix(messageUtils.removeJidResource(chatStateMessage.from) || '');

      return state.setIn(['byId', chatId], {
        chatStateType,
        updatedTime: +new Date(),
      });
    }

    case types.USER_LOGOUT_SUCCESS: {
      // Reset to initial state
      return initialState.chatState;
    }

    default:
      return state;
  }
}
